'use client';

import React from 'react';
import Link from 'next/link';
import { useAnchorScroll } from '../../hooks/useAnchorScroll';

/**
 * AnchorLink — A lightweight client component for smooth anchor scrolling.
 * Use this within Server Components (like Footer) to keep the parent static.
 */
export const AnchorLink = ({ href, children, className, onClick, ...props }) => {
    const handleAnchorClick = useAnchorScroll();

    const handleClick = (e) => {
        handleAnchorClick(e, href);
        if (onClick) onClick(e);
    };

    return (
        <Link href={href} className={className} onClick={handleClick} {...props}>
            {children}
        </Link>
    );
};
